

















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import commonService from '@/services/common-services';
import { PayAuthorityModel } from '@/models/payauthority';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class PayAuthorityInfo extends Vue {
    @Prop({default: null})
    private payauthority!: PayAuthorityModel;

    get configuration() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].configuration;
    }
    
    get acceptAccounts()  {
        if (this.payauthority && this.payauthority.AcceptPayAccount && this.configuration !== undefined) {
            const accepted = this.payauthority.AcceptPayAccount.split(',');
            let accounts = JSON.parse(this.configuration.AuthAccounts);
            return accounts.filter(p => accepted.indexOf(String(p.value)) !== -1 && p.active);
        }
        
        return [];
    }
    mainOrderStatus(id) {
        const status = DATA.payauthorityStatus.find(x => x.value === id);
        if (status) return status.name;
        return '';
    }

    private async getConfiguration() {
        const result = await commonService.configuration();
        if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_CONFIGURATION', result.data.data);
        }
    }
    private async created() {
        await this.getConfiguration();
    }

    private addRow() {
        if (this.payauthority.OrderCodes) {
            const error = this.payauthority.OrderCodes.find(c => !c.Amount || !c.PayID || !c.OrderCode);
            if (error) {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: `Các trường Giá trị, mã đơn và tài khoản ủy quyền bắt buộc phải nhập trong mỗi lệnh`,
                });
            } else {
                let amountTotal = this.payauthority.OrderCodes.map(o => o.Amount).reduce((a, b) => Number(a) + Number(b), 0) || 0;
                amountTotal = Math.round(amountTotal * 100) / 100;
                if (Number(amountTotal) > Number(this.payauthority.Amount)){
                    Vue.notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Thông báo!',
                        text: `Tổng giá trị các lệnh vượt quá giá trị yêu cần ủy quyền thanh toán ban đầu`,
                    });
                } else {
                    this.payauthority.OrderCodes.push({
                        ID: 0,
                        ParentID: this.payauthority.ID,
                        Cancelled: 0,
                        Amount: 0,
                        OrderCode: "",
                        LinkPay: "",
                        Note: "",
                        PayID: this.payauthority.AcceptPayAccount && this.payauthority.AcceptPayAccount.indexOf(',') === -1 ? Number(this.payauthority.AcceptPayAccount) : 0
                    });
                }
            }
        }
    }
    
    private copyText(event) {
        const el = event.target.parentElement.closest('.row-copy').querySelector('input');
        if (el) {
            el.select();
            document.execCommand("copy");
        } else {
            const el = event.target.parentElement.closest('.row-copy').querySelector('select');
            if(el) {
                var range = document.createRange();
                range.selectNode(el);
                var selection = window.getSelection();
                if (selection) {
                    selection.removeAllRanges();
                    selection.addRange(range);
                    document.execCommand("copy");
                    selection.removeAllRanges();
                }
            }
        }    
    }
}
